import orig from "../../ui/shared/signup-dialog/jquery/index.coffee";
import ext0 from "../../gems/plugins/instructure_misc_plugin/app/coffeescripts/extensions/registration/signupDialog.coffee";
export default ext0(orig);
